<template>
  <div class="margin-top">
    <el-table :data="rooms" style="width: 100%">
      <el-table-column prop="roomNum" label="房屋编号" align="center">
        <template slot-scope="scope">
          {{ scope.row.roomName || scope.row.roomNum || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="floorNum" label="楼层" align="center" />
      <el-table-column prop="roomType" label="类型" align="center">
        <template slot-scope="scope">{{ scope.row.roomTypeName || scope.row.roomType || '-' }}</template>
      </el-table-column>
      <el-table-column label="建筑/室内面积" align="center">
        <template slot-scope="scope">
          {{ (scope.row.builtUpArea || scope.row.builtArea || '-') + '/' + (scope.row.roomArea || scope.row.insideArea || '-') }}
        </template>
      </el-table-column>
      <el-table-column prop="rent" label="租金" align="center" />
      <el-table-column label="有效期" align="center">
        <template slot-scope="scope">
          {{ scope.row.startTime || '-' }}<br />~{{ scope.row.endTime || '-' }}
        </template>
      </el-table-column>
      <el-table-column label="房屋状态" align="center">
        <template slot-scope="scope">
          <span :class="statusClass(scope.row)">{{ statusText(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="oweFee" label="房屋欠费" align="center">
        <template slot-scope="scope">{{ formatOwe(scope.row) }}</template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="16" :offset="8">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="row"
          layout="total, prev, pager, next"
          :total="total"
        />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getContractRooms } from '@/api/contract/contractDetailApi'

export default {
  name: 'ContractQueryRoom',
  data() {
    return {
      contractId: '',
      rooms: [],
      page: 1,
      row: 10,
      total: 0
    }
  },
  methods: {
    open(data) {
      this.contractId = data.contractId
      this.page = 1
      this._load()
    },
    handleCurrentChange(val) {
      this.page = val
      this._load()
    },
    async _load() {
      if (!this.contractId) return
      try {
        const res = await getContractRooms({ contractId: this.contractId, page: this.page, row: this.row })
        this.rooms = res.data || res.rooms || []
        this.total = res.total || this.rooms.length
      } catch (e) {
        console.error('获取合同房屋失败', e)
      }
    },
    statusText(row) {
      const s = row.state || row.stateName
      if (s === 2001 || s === '2001' || s === '已入住' || s === '入住') return '已入住'
      if (s === 1001 || s === '1001' || s === '未销售') return '未销售'
      return row.stateName || s || '-'
    },
    statusClass(row) {
      const t = this.statusText(row)
      return {
        'status-badge': true,
        'status-green': t === '已入住',
        'status-gray': t === '未销售'
      }
    },
    formatOwe(row) {
      const v = row.oweAmount || row.arrears || row.oweFee
      if (v === null || v === undefined || v === '') return '-'
      return v
    }
  }
}
</script>

<style scoped>
.margin-top { margin-top: 20px; }
.status-badge {
  display: inline-block;
  min-width: 66px;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  border: 1px solid #8C9BB4;
  color: #8C9BB4;
  background: rgba(140,155,180,0.10);
}
.status-green {
  color: #21B956;
  border-color: #21B956;
  background: rgba(33,185,86,0.10);
}
.status-gray {
  color: #8C9BB4;
  border-color: #8C9BB4;
  background: rgba(140,155,180,0.10);
}
</style>
